export enum OfferActionTypes {
  GetPublishedOffers = 'GetPublishedOffers',
  GetUnpublishedOffers = 'GetUnpublishedOffers',
  GetDraftOffers = 'GetDraftOffers',
  UpdatePublishedOffers = 'UpdatePublishedOffers',
  UpdateDraftOffers = 'UpdateDraftOffers',
  UpdateOfferFilter = 'UpdateOfferFilter',
  UpdateCryptoCurrencyRates = 'UpdateCryptoCurrencyRates',
  ClearOffers = 'ClearOffers',
  LoadMorePublishedOffers = 'LoadMorePublishedOffers',
  LoadMoreUnpublishedOffers = 'LoadMoreUnpublishedOffers',
  SetLoadingMore = 'SetLoadingMore',
  SetHasMore = 'SetHasMore',
}
